import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

const MultiValueLabel = props => {
  const {
    data: { value: propsValue },
    selectProps: {
      input: { name }
    }
  } = props;
  const value = typeof propsValue === 'string' ? propsValue.split(' ').join('-') : '';
  return (
    <div style={{ width: '97%' }} data-desc={`select__${name}_option_${value}_label`}>
      <components.MultiValueLabel {...props} />
    </div>
  );
};

MultiValueLabel.propTypes = {
  children: PropTypes.any.isRequired,
  selectProps: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default MultiValueLabel;
